import React, { useEffect, useMemo } from 'react';
import PerformanceUtils from 'services/PerformanceUtils';
import FaxList from 'components/HealthRecords/Faxes/FaxList';
import {useAppDispatch} from "careand-redux/useAppDispatch";
import {useAppSelector} from "careand-redux/store";
import {api} from "careand-redux/api/ApiThunks";

const PatientFaxes = ({ patient, autoLoad = true }) => {
  const patientId = patient.id;

  const dispatch = useAppDispatch();
  const allFaxes = useAppSelector(state => state.fax.patients);

  const patientFaxes = allFaxes[patientId];

  const sortedFaxes = useMemo(
    () => PerformanceUtils.sortBy(patientFaxes || []),
    [patientFaxes]
  );

  useEffect(
    () => {
      dispatch(api.Fax.getPatientFaxes({patientId}));
    },
    [dispatch, patientId]
  );

  return (
    <FaxList
      key="faxes"
      patient={patient}
      title="Faxes"
      faxes={sortedFaxes}
      autoLoad={autoLoad}
    />
  );
};

export default PatientFaxes;
